<div class="d-flex justify-content-center flex-center h-100" style="height: 100vh">
	<div class="h3 mx-auto my-auto p-5 text-center">{{ message }}</div>
</div>
